// @flow
import React, { lazy } from 'react'
import { PrivateRoute } from 'src/common/components'

const InsurancesList = lazy(() => import('src/modules/myInsurances/insurancesList'))

export default [
  <PrivateRoute exact={true} path="/my-insurances" component={InsurancesList} key="my-insurances"/>,
]
